import moment from 'moment';

export class WorkdayModel {
    public workDuration: moment.Duration;
    public workDate: moment.Moment;
    public previousTimesheetDuration: moment.Duration;
    public constructor(date: moment.Moment, totalHours?: moment.Duration, previousTimesheetDuration?: moment.Duration) {
        this.previousTimesheetDuration = moment.duration(previousTimesheetDuration ?? 0);
        this.workDate = date.clone();
        this.workDuration = moment.duration(totalHours ?? 0);
    }
}

export class WorkdayModelFromJson extends WorkdayModel {
    public constructor(data: JsonWorkDayModel) {
        super(
            moment(data.workDate),
            moment.duration(data.workDuration),
            moment.duration(data.previousTimesheetDuration),
        );
    }
}

export interface JsonWorkDayModel {
    workDuration: string;
    workDate: string;
    previousTimesheetDuration: string;
}
